import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';
import NewLesson from "../Lessons/New";
import { NavigationDrawer } from "../Shared/Toolbox";
import Workspace from "../../types/Workspace";
import Dashboard from "../Dashboard/Dashboard";
import User from "../../types/User";
import Chat from "../Conversations/Chat";
import Sidebar from "./Sidebar";
import ShowLesson from "../Lessons/Show";
import ShowSolution from "../Solutions/Show";
import LessonsList from "../Lessons/List";
import { Box, Container, Toolbar } from "@mui/material";
import { ToggleButton } from "../Shared/UserNav";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Layout from "./Application";
import { AppProps } from "../App";
import SolutionsList from "../Solutions/List";

export type StartProps = {
  user: User;
  workspace: Workspace;
}
 
const MainApp = (props: AppProps & StartProps) => {

  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));

  const [prompt, setPrompt] = useState<string>("");
  const [sidebarOpen, showSidebar] = useState<boolean>(!isMobile);

  const { pathname } = useLocation();
  const { conversationId, lessonId, solutionId } = useParams();
  const navigate = useNavigate();

  const openLesson = (lessonId: string) => {  
    navigate(`/lessons/${lessonId}`);
  };

  const renderSelectedContent = () => {
    switch(pathname) {
      case '/lessons/new':
        return <NewLesson onConversationCreate={(conversationId: string, prompt: string) => {
          setPrompt(prompt);
          navigate(`/conversations/${conversationId}`);
        }} />
      case `/conversations/${conversationId}`:
        return <Chat prompt={prompt} />
      case `/lessons/${lessonId}`:
        return <ShowLesson id={lessonId!} user={props.user} />
      case `/solutions/${solutionId}`:
        return <ShowSolution id={solutionId!} user={props.user} />
      case `/lessons`:
        return <LessonsList {...props} onOpen={openLesson} />
      case `/solutions`:
      case `/solutions/new`:
        return <SolutionsList {...props} onOpen={openLesson} />
      default:
        return <Dashboard {...props} onOpen={openLesson} />
    }
  }

  return <CookiesProvider defaultSetOptions={{ path: '/' }}>
    <Layout variant="application" {...props}>
      <NavigationDrawer
        menu={<Box className="bg-dark" 
                   sx={{flex: 1, display: "flex", flexDirection: "column"}}>
          <Sidebar {...props} 
                    open={sidebarOpen} 
                    onToggle={() => showSidebar(isOpen => !isOpen)} 
                    toggleAfterClick={isMobile} />
        </Box>} 
        currentContent={<>
          <Toolbar sx={{width: "100%", display: sidebarOpen ? 'none' : 'inline-flex', ml: 4}} disableGutters>
            <ToggleButton open={sidebarOpen} onToggle={() => showSidebar(isOpen => !isOpen)} />
          </Toolbar>
          {renderSelectedContent()}
        </>}
        sx={{zIndex: 2, 
             width: { xs: 'auto', md: sidebarOpen ? "20vw" : "auto" },
             display: { xs: sidebarOpen ? 'flex' : 'none', md: 'flex' },
             boxShadow: "var(--box-shadow)"}} />
    </Layout>
  </CookiesProvider>;
}

export default MainApp;